import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useAppDownloadModal = () => {
  const [showAppDownloadModal, setShowAppDownloadModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    const shouldShowModal = (location.state as any)?.showAppDownloadModal;

    if (shouldShowModal && currentPath === '/dashboard') {
      const timer = setTimeout(() => {
        setShowAppDownloadModal(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [location.pathname, location.state]);

  const handleAppDownloadModalClose = () => {
    setShowAppDownloadModal(false);
  };

  const navigateWithModal = (to: string, options?: any) => {
    navigate(to, {
      ...options,
      state: {
        ...options?.state,
        showAppDownloadModal: true
      }
    });
  };

  return {
    showAppDownloadModal,
    handleAppDownloadModalClose,
    navigateWithModal
  };
};

export default useAppDownloadModal;
